import { headlineMedium, screenMdMin, titleLarge, screenLgMin, headlineLarge, Text, } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled from 'styled-components';
import { formatText, responsiveText } from '../utils';
const Headline = styled(Text) `
  display: block;
  width: 100%;
  ${({ useLargeText }) => responsiveText(headlineMedium, {
    [screenMdMin]: titleLarge,
    [screenLgMin]: headlineMedium,
    '1440px': useLargeText ? headlineLarge : headlineMedium,
})};
`;
export const ResponsiveHeadline = ({ headline, useLargeText }) => {
    return (React.createElement(Headline, { className: "headline", "data-testid": "hero-body-headline", useLargeText: useLargeText, dangerouslySetInnerHTML: {
            __html: formatText(headline),
        } }));
};
